module.exports = __webpack_public_path__ + "img/edge_nature_terroir.8e7c5858.svg";